const dialogsData = [
  {
    id: "hotelSelector",
    ref: "hotelSelector",
    titleKey: "selectHotel",
    width: "400",
    includeActions: false,
    content: "hotel-selector",
    show: true,
  },
  {
    id: "changeFilters",
    ref: "paymentsFilters",
    titleKey: "changeFilters",
    width: "320",
    includeActions: true,
    content: "payments-filters",
    show: true,
  },
  {
    id: "createPayment",
    ref: "createPayment",
    titleKey: "createPayment",
    width: "500",
    fullCardDialog: true,
    content: "create-payment",
    show: true,
  },
  {
    id: "advancedSearch",
    ref: "advancedSearch",
    titleKey: "advancedSearch",
    width: "320",
    includeActions: true,
    content: "advanced-search",
    show: true,
  },
  {
    id: "createPaymentLink",
    ref: "createPaymentLink",
    titleKey: "createPaymentLink",
    width: "500",
    includeActions: true,
    content: "create-payment-link",
    show: true,
  },
  {
    id: "paymentDetails",
    ref: "paymentDetails",
    titleKey: "paymentDetails",
    width: "90%",
    includeActions: false,
    content: "payment-details",
    show: true,
  },
  {
    id: "setVccAmount",
    ref: "setVccAmount",
    titleKey: "setVccAmount",
    width: "320",
    includeActions: true,
    content: "set-vcc-amount",
    show: true,
  },
  {
    id: "addVirtualCard",
    ref: "addVirtualCard",
    titleKey: "addVirtualCard",
    width: "600",
    includeActions: true,
    content: "add-virtual-card",
    show: true,
  },
  {
    id: "modifyPaymentLink",
    ref: "modifyPaymentLink",
    titleKey: "modifyPaymentLink",
    width: "500",
    includeActions: true,
    content: "modify-payment-link",
    show: true,
  },
  {
    id: "plainTextMail",
    ref: "plainTextMail",
    titleKey: "plainTextVersion",
    width: "500",
    includeActions: true,
    content: "plain-text-mail",
    show: true,
  },
  {
    id: "resetPassword",
    ref: "resetPassword",
    titleKey: "resetPassword",
    width: "360",
    includeActions: true,
    content: "reset-password",
    show: true,
  },
  {
    id: "setReportsOverviewDates",
    ref: "setReportsOverviewDates",
    titleKey: "setStartDate",
    width: "320",
    includeActions: false,
    content: "reports-date-picker-filter",
    show: true,
  },
  {
    id: "createPaymentForReservation",
    ref: "createPaymentForReservation",
    titleKey: "createPaymentForReservation",
    width: "800",
    fullCardDialog: true,
    content: "create-payment-for-reservation",
    show: true,
  },
  {
    id: "extendPaylink",
    ref: "extendPaylink",
    titleKey: "extendPaylink",
    width: "320",
    includeActions: true,
    content: "extend-paylink",
    show: true,
  },
  {
    id: "verify2faCode",
    ref: "verify2faCode",
    titleKey: "verify2faCode",
    width: "320",
    includeActions: false,
    content: "verify-2fa-code",
    show: true,
  },
];

export { dialogsData };
